import { default as FNS } from '../api';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';

/**
 * Private (internal-only) notes attached to a job/query, keyed by query id.
 * Only admins can read or write these; they are never shown to clients or drivers.
 */

export const fetchPrivateNotes = createAsyncThunk('privateNotes/fetch', async ({ id }, { dispatch }) => {
  try {
    const notes = await FNS.getPrivateNotes(id);
    dispatch(privateNotesSlice.actions.replaceForQuery({ id, notes }));
    return notes;
  } catch (e) {
    toast.error(e.message);
  }
});

export const addPrivateNote = createAsyncThunk('privateNotes/add', async ({ id, content }, { dispatch }) => {
  try {
    const res = await FNS.addPrivateNote(id, content);
    await dispatch(fetchPrivateNotes({ id }));
    return res;
  } catch (e) {
    toast.error(e.message);
  }
});

export const updatePrivateNote = createAsyncThunk('privateNotes/update', async ({ id, noteId, content }, { dispatch }) => {
  try {
    const res = await FNS.updatePrivateNote(noteId, content);
    await dispatch(fetchPrivateNotes({ id }));
    return res;
  } catch (e) {
    toast.error(e.message);
  }
});

export const deletePrivateNote = createAsyncThunk('privateNotes/delete', async ({ id, noteId }, { dispatch }) => {
  try {
    const res = await FNS.deletePrivateNote(noteId);
    await dispatch(fetchPrivateNotes({ id }));
    return res;
  } catch (e) {
    toast.error(e.message);
  }
});

const privateNotesSlice = createSlice({
  name: 'privateNotes',
  initialState: {},
  reducers: {
    replaceForQuery: (state, { payload: { id, notes } }) => {
      state[id] = notes || [];
    },
  },
});

export default privateNotesSlice.reducer;
